module.exports = __webpack_public_path__ + "static/media/45_B.3132ebfb.png";